import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Dashboard, { DashboardSection } from '@g17eco/molecules/dashboard';
import CONFIG from '../../config';
import { useAppSelector } from '../../reducers';
import { getRootOrg } from '../../selectors/initiative';
import { loggerMessage } from '../../logger';

export const SGXSunset = () => {
  const organization = useAppSelector(getRootOrg);

  useEffect(() => {
    const who = organization ? `Customer "${organization.name}"` : 'Anonymous user';
    loggerMessage(`${who} reached ESGenome sunset page`, {
      level: 'info',
      organization,
    });
  }, [organization]);

  return (
    <div className='d-flex'>
      <Dashboard className='flex-fill'>
        <DashboardSection>
          <h4>Service retired</h4>
          <p>
            ESGenome has been retired. If you need access to your historical data or have any
            questions, please contact our support team.
          </p>
          <p>
            <a href={`mailto:${CONFIG.emailSupport}?subject=ESGenome%20retirement`}>
              Contact support
            </a>
          </p>
          <Link to='/'>Go to homepage</Link>
        </DashboardSection>
      </Dashboard>
    </div>
  );
};
